import { useScrollReveal } from '@/hooks/useScrollReveal';

const articles = [
  {
    slug: '/blog/prix-toiture-levis-2026',
    title: 'Prix toiture Lévis 2026 — Guide complet des coûts',
    excerpt: 'Bardeaux, tôle, membrane... Découvrez les tarifs actualisés et les facteurs qui influencent le prix de votre toiture.',
    image: 'https://readdy.ai/api/search-image?query=Modern Quebec residential house with brand new asphalt shingle roof in suburban neighborhood of L\u00e9vis Quebec Canada, autumn afternoon with warm golden light, clean architectural lines, well maintained property with maple trees, documentary real estate photography style, warm natural tones, no text visible, landscape composition 16:9',
    readTime: '8 min',
    tag: 'Prix',
  },
  {
    slug: '/blog/comment-choisir-couvreur-levis',
    title: 'Comment choisir un bon couvreur à Lévis ?',
    excerpt: 'Les 7 critères essentiels pour sélectionner un entrepreneur qualifié, certifié RBQ et recommandé dans la région.',
    image: 'https://readdy.ai/api/search-image?query=Professional roofer inspecting residential roof in Quebec Canada, wearing safety harness and hard hat, clear blue sky, well maintained asphalt shingles, daytime photography with natural light, warm tones, professional trade work, no text visible, landscape composition 16:9',
    readTime: '6 min',
    tag: 'Conseils',
  },
  {
    slug: '/blog/signes-toiture-a-refaire',
    title: '5 signes que votre toiture doit être refaite',
    excerpt: 'Bardeaux qui s\u2019en vont, infiltrations, granulettes au sol... Apprenez à repérer les signes d\u2019alerte avant qu\u2019il ne soit trop tard.',
    image: 'https://readdy.ai/api/search-image?query=Aged damaged asphalt shingle roof with missing shingles and visible wear on residential Quebec house, overcast grey sky, signs of water infiltration, documentary style photography showing real roofing problems, muted natural tones, no text visible, landscape composition 16:9',
    readTime: '5 min',
    tag: 'Diagnostic',
  },
];

export default function BlogCards() {
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE(path);
  };

  return (
    <section className="bg-soft-gray py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div
          className={`text-center mb-10 md:mb-14 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-3">
            En attendant, lisez nos guides :
          </h2>
          <p className="text-slate-primary/50 text-sm md:text-base">
            Informez-vous avant de recevoir vos soumissions
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, idx) => (
            <button
              key={idx}
              onClick={() => navigateTo(article.slug)}
              className={`group bg-white rounded-xl overflow-hidden text-left transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <div className="overflow-hidden rounded-t-xl">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  width="400"
                  height="300"
                  height="200"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-copper/10 text-copper text-xs font-bold tracking-wide uppercase px-2.5 py-0.5 rounded-full">
                    {article.tag}
                  </span>
                  <span className="text-slate-primary/40 text-xs flex items-center gap-1">
                    <i className="ri-time-line" />
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-manrope font-bold text-slate-primary text-base md:text-lg mb-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-slate-primary/50 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-copper text-sm font-semibold mt-4 group-hover:gap-2 transition-all">
                  Lire l&apos;article
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}